import type { CSSProperties } from 'react';

import classNames from 'classnames';

import { useDreamComponentsContext } from '../../dreamComponentProvider/hooks';
import type { NavbarMenuBurgerContentElementProps } from '../../navbarElement/Navbar.type';
import * as styles from '../Navbar.css';

export function NavbarMenuBurgerContentV2(props: NavbarMenuBurgerContentElementProps) {
  const { element, children, className, attributes } = props;
  const { customAttributes } = element.attrs || {};

  // Not a prop: the serializer builds this node before the burger that wraps it, so the burger has
  // no way to inject one. Resolved exactly as NavbarMenuBurger resolves it.
  const { navbarBurger } = useDreamComponentsContext();
  const hostOpen = attributes?.['data-is-open'];
  const isOpen = hostOpen === undefined ? Boolean(navbarBurger?.isOpen) : hostOpen === true;

  return (
    // biome-ignore lint/a11y/useValidAriaRole: none
    <div
      {...props}
      role="none"
      {...customAttributes}
      {...attributes}
      className={classNames(styles.navbarMenuBurgerContentV2)}
      style={
        {
          maxHeight: isOpen ? 'var(--content-max-height, 100dvh)' : '0px',
          height: isOpen ? 'fit-content' : '0px',
          overflow: isOpen ? 'auto' : 'hidden',
          overscrollBehavior: 'contain',
          opacity: isOpen ? 1 : 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          justifyContent: 'start',
        } as CSSProperties
      }
    >
      {/* biome-ignore lint/a11y/useValidAriaRole: none */}
      <div
        role="none"
        className={classNames(
          styles.navbarMenuBurgerContentInnerV2,
          className,
          customAttributes?.className,
          'navbar-menu-burger-content',
        )}
        style={
          {
            width: '100%',
          } as CSSProperties
        }
      >
        {children}
      </div>
    </div>
  );
}
